<template>
  <div v-if="expanded" class="expanded">
    <div class="expanded-row">
      <p class="label">
        {{ $t('voucher.label') }}
      </p>
      <div class="voucher-row">
        <input type="text" v-model="voucher" class="voucher-input" :placeholder="$t('voucher.placeholder')" />
      </div>
    </div>
    <span v-if="invalid" class="error">{{ $t('voucher.error') }}</span>
  </div>
</template>

<script lang="ts">
import { computed, ref, watch, defineComponent } from 'vue';
import { useMixpanel } from '@/composables/useMixpanel';
import { TrackEvents } from '@/types/trackEvents';

export default defineComponent({
  name: 'VoucherCard',
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    invalid: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['update:expanded', 'update:modelValue'],
  setup(props, { emit }) {
    const { track } = useMixpanel();
    const hasTracked = ref(false);

    watch(
      () => props.expanded,
      (expanded) => {
        if (expanded && !hasTracked.value) {
          track(TrackEvents.REDEEM_VOUCHER_VIEW);
          hasTracked.value = true;
        }
      },
    );

    const voucher = computed({
      get: () => props.modelValue,
      set: (val: string) => emit('update:modelValue', val),
    });

    return {
      voucher,
    };
  },
});
</script>

<style scoped lang="scss">
.expand-toggle {
  color: $color-primary;
}

.label {
  @extend %label;
}

.voucher-button {
  @extend %secondary-button;
  font-weight: bold;
}

.expanded {
  margin-top: 8px;
}

.expanded-row {
  display: flex;
  flex-direction: column;
}

.voucher-row {
  display: flex;
}

.voucher-input {
  width: 100%;
}

.error {
  color: $color-danger;
  font-size: 14px;
}
</style>
